import {AstView, EnrichedAstNode} from '../types';
import {recalculateInnerPosition, visitor} from '../helpers';
import {calculateUnits} from './CalculateLayoutSettings';

export function calculateLayoutStable(tree: EnrichedAstNode, view: AstView) {
    // requires calculated layout to start
    // applies user input over this layout.

    visitor(tree, view.meta, (currentNode) => {
        const result = {
            ...currentNode.calculatedLayoutAbstraction,
            ...currentNode.inputLayoutAbstraction,
        };

        recalculateInnerPosition(currentNode);

        currentNode.calculatedLayoutAbstraction = result;
        result.units = calculateUnits(currentNode.inputLayoutAbstraction, currentNode.calculatedLayoutAbstraction);
    });
}
